var map = {
	"./akin.jpeg": 260,
	"./apt.jpeg": 650,
	"./code.jpeg": 383,
	"./daniel.jpeg": 386,
	"./des.jpeg": 370,
	"./devsuite.jpeg": 830,
	"./eniola.jpeg": 651,
	"./kamal.jpeg": 682,
	"./kb.jpeg": 599,
	"./madza.jpeg": 389,
	"./petty.jpeg": 450,
	"./roman.jpeg": 827,
	"./sam.jpeg": 360,
	"./zul.jpeg": 761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 663;